import { createFileRoute, Outlet } from '@tanstack/react-router';
import { LogoutInfo } from 'components/logout-info-dialog';
import { useSelector } from 'react-redux';
import { useUpdateCommunityAccount } from 'services/communityAccount/communityAccount.hooks';
import { useValidateSession } from 'services/session/session.hooks';
import { selectIsSessionValidated } from 'services/session/session.selectors';

export const Route = createFileRoute('/_auth')({
  component: function AuthRoute() {
    const isSessionValidated = useSelector(selectIsSessionValidated);
    useValidateSession();
    useUpdateCommunityAccount(isSessionValidated);

    if (!isSessionValidated) return null;

    return (
      <>
        <Outlet />
        <LogoutInfo />
      </>
    );
  },
});
